<template>
  <section class="score-dashbord-wrapper" :class="fissionGame">
    <div class="notice-wrapper flex-center" :class="type">
      <div class="notice-wrapper-bar">
        <van-notice-bar :scrollable="false" wrapable>
          <van-swipe
            vertical
            class="score-swipe"
            :autoplay="1500"
            :show-indicators="false"
            :touchable="false"
          >
            <van-swipe-item v-for="(item, index) in dataSource" :key="index">{{
              item
            }}</van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>
    </div>
    <div class="score-body-wrapper" v-if="showAward" :class="fissionGame">
      <div class="score-bar">
        <p class="title">{{ $t('fission.obtained') }}</p>
        <div
          v-show="fissionGame === 'mobile-legends'"
          class="handle-btn"
          @click="toExchange"
        >
          <span class="text">{{ $t('fission.extract') }}</span>
          <MBIcon :size="35" name="icon-arrow" color="#fff" />
        </div>
        <div class="score-wrapper">
          <span class="score">{{ number }}</span>
          <img
            class="score-icon"
            v-lazy="
              require(`@/assets/images/activities/fission/${fissionGame}/score-icon.png`)
            "
            alt="logo"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import { dataSource as mockData } from './datas'
  import { fission_exchange } from '../../firebase'
  import MBIcon from '@/components/MBIcon'

  export default {
    components: {
      MBIcon,
    },
    props: {
      type: {
        type: String,
        default: 'page',
      },
      number: {
        type: Number,
        default: 0,
      },
      activityId: {
        type: String,
        default: '',
      },
      swipeList: {
        type: Array,
        default: () => [],
      },
      showAward: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(['fissionGame', 'fissionInfos']),
      dataSource() {
        return this.swipeList || mockData
      },
    },
    methods: {
      toExchange() {
        this.$emit('to-exchange')
        fission_exchange({
          page: 'fission',
        })
        this.$router_push({
          path: '/fission-exchange',
          query: {
            ...this.$route.query,
            activityId: this.activityId,
          },
        })
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped>
  .notice-wrapper {
    height: 60px;
    padding: 0 40px;
    box-sizing: border-box;
  }
  .score-dashbord-wrapper >>> .van-notice-bar {
    height: 60px;
    background-color: unset;
  }
  .score-dashbord-wrapper >>> .van-notice-bar .score-swipe {
    height: 60px;
    line-height: 60px;
  }
  .score-dashbord-wrapper >>> .van-notice-bar .score-swipe .van-swipe__track {
    display: flex;
    justify-content: center;
    color: #ffffff;
  }
  .score-dashbord-wrapper >>> .van-notice-bar--wrapable {
    padding: 0;
    width: 100%;
  }
  .score-dashbord-wrapper >>> .van-notice-bar__content {
    width: 100%;
  }
  .score-dashbord-wrapper
    >>> .van-notice-bar
    .score-swipe
    .van-swipe__track
    .van-swipe-item {
    display: flex;
    justify-content: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
